import { GlTooltipDirective, GlLink, GlButton, GlCollapse, GlIcon, GlBadge } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { difference, get } from 'lodash-es';
import { __, s__, sprintf } from '~/locale';
import { InternalEvents } from '../../tracking/index.js?vue3';
import { ASSET_LINK_TYPE, CLICK_EXPAND_ASSETS_ON_RELEASE_PAGE } from '../constants';
export default {
    name: 'ReleaseBlockAssets',
    components: {
        GlLink,
        GlButton,
        GlCollapse,
        GlIcon,
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        InternalEvents.mixin()
    ],
    props: {
        assets: {
            type: Object,
            required: true
        },
        expanded: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data () {
        return {
            isAssetsExpanded: this.expanded
        };
    },
    computed: {
        imageLinks () {
            return this.linksForType(ASSET_LINK_TYPE.IMAGE);
        },
        packageLinks () {
            return this.linksForType(ASSET_LINK_TYPE.PACKAGE);
        },
        runbookLinks () {
            return this.linksForType(ASSET_LINK_TYPE.RUNBOOK);
        },
        otherLinks () {
            return difference(this.assets.links, [
                ...this.imageLinks,
                ...this.packageLinks,
                ...this.runbookLinks
            ]);
        },
        sections () {
            return [
                {
                    links: get(this.assets, 'sources', []).map((s)=>({
                            url: s.url,
                            name: sprintf(__('Source code (%{fileExtension})'), {
                                fileExtension: s.format
                            })
                        })),
                    iconName: 'doc-code'
                },
                {
                    title: s__('ReleaseAssetLinkType|Images'),
                    links: this.imageLinks,
                    iconName: 'container-image'
                },
                {
                    title: s__('ReleaseAssetLinkType|Packages'),
                    links: this.packageLinks,
                    iconName: 'package'
                },
                {
                    title: s__('ReleaseAssetLinkType|Runbooks'),
                    links: this.runbookLinks,
                    iconName: 'book'
                },
                {
                    title: s__('ReleaseAssetLinkType|Other'),
                    links: this.otherLinks,
                    iconName: 'link'
                }
            ].filter((section)=>section.links.length > 0);
        }
    },
    methods: {
        toggleAssetsExpansion () {
            this.isAssetsExpanded = !this.isAssetsExpanded;
            if (this.isAssetsExpanded) {
                this.trackEvent(CLICK_EXPAND_ASSETS_ON_RELEASE_PAGE);
            }
        },
        linksForType (type) {
            return this.assets.links.filter((l)=>l.linkType === type);
        },
        getTooltipTitle (section) {
            return section.title ? this.$options.externalLinkTooltipText : this.$options.downloadTooltipText;
        },
        getIconName (section) {
            return section.title ? 'external-link' : 'download';
        }
    },
    externalLinkTooltipText: __('This link points to external content'),
    downloadTooltipText: __('Download')
};
